export default __webpack_public_path__ + "static/media/1.7e73c5b7.png";